import { getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { toNum } from '@shared/helpers/math.helper';
import { addDays, format } from 'date-fns';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { getConclusioniControl } from '../../validators/helpers/conclusioni-form.helper';
import { cloneDeep } from 'lodash-es';

export const calcolaDataScadenzaDiffida = (form: FormGroup, store: Store<Revisione53State>): void => {
    const ckProposte = getConclusioniControl(form, 'my_CkProposte').value as string;
    const ggDiffidaRaw = getConclusioniControl(form, 'my_ggDiffida').value;
    const dataCompilazRaw = getConclusioniControl(form, 'my_DataCompilaz').value as string;

    let dataScadenza = '';

    if (ckProposte === '3' && !isNilOrEmpty(ggDiffidaRaw) && !isNilOrEmpty(dataCompilazRaw)) {
        const dataFirmaRilevazione = new Date(dataCompilazRaw);

        if (!isNaN(dataFirmaRilevazione.getTime())) {
            const ggDiffida = toNum(ggDiffidaRaw) + 1;
            dataScadenza = format(addDays(dataFirmaRilevazione, ggDiffida), 'yyyy-MM-dd');
        }
    }

    getConclusioniControl(form, 'my_DataScadenzaDiffida').patchValue(dataScadenza, {
        emitEvent: false,
    });

    updateVerbaleOnStore(store, (myVerbale) => {
        const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);

        myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni.my_DataScadenzaDiffida = dataScadenza;

        return myVerbaleClone;
    });
};

export const calcolaDataScadenzaAccertamento = (form: FormGroup, store: Store<Revisione53State>): void => {
    const dataScadenzaAccertamentoControl = getControl(form, 'my_SezioneII__Accertamento.my_DataScadenzaAccertamento');

    updateVerbaleOnStore(store, (myVerbale) => {
        const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);

        const conclusioni = myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni;
        const accertamento = myVerbaleClone.my_SezioneII__Accertamento;

        if (!accertamento) {
            return myVerbaleClone;
        }

        const esitoRilevazione = conclusioni.my_CkProposte;
        const ggDiffidaRaw = conclusioni.my_ggDiffida;
        const dataFirmaRilevazioneRaw = conclusioni.my_DataCompilaz;
        const dataFirmaAccertamento = accertamento.my_DataCompilazII;

        if (isNilOrEmpty(dataFirmaAccertamento)) {
            return myVerbaleClone;
        }

        let dataScadenza = '';

        if (esitoRilevazione === '3' && !isNilOrEmpty(ggDiffidaRaw) && !isNilOrEmpty(dataFirmaRilevazioneRaw)) {
            const dataFirmaRilevazione = new Date(dataFirmaRilevazioneRaw);

            if (!isNaN(dataFirmaRilevazione.getTime())) {
                const ggDiffida = toNum(ggDiffidaRaw);
                const dataFineDiffida = addDays(dataFirmaRilevazione, ggDiffida);

                dataScadenza = format(addDays(dataFineDiffida, 30), 'yyyy-MM-dd');
            }
        }

        accertamento.my_DataScadenzaAccertamento = dataScadenza;

        dataScadenzaAccertamentoControl?.patchValue(dataScadenza, {
            emitEvent: false,
        });

        return myVerbaleClone;
    });
};
